import React from 'react';
import '../.././components/css/popupstyle.css';
import EditScreenPopup from '../.././components/Wholesaler/OveridePopup';
import ConfirmationPopup from '../../components/Wholesaler/GroupConfirmationPopup';
import { userService } from '../../_services';
import UserIcon from '../.././components/css/dark/img/user.svg';
import EditIcon from '../.././components/css/dark/img/edit2.svg';
import ResetIcon from '../.././components/css/dark/img/reset.png';
import GlobeIcon from '../.././components/css/dark/img/globe-icon.png';
import RequestGroupNumber from '../.././components/Wholesaler/RequestGroupNumber';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import { debuglog } from 'util';
import ResendIcon from '../.././components/css/dark/img/theme-images/paper-plane-regular.svg';
import CopyIcon from '../.././components/css/dark/img/theme-images/copy-regular.svg';
import copy from "copy-to-clipboard";
import InfoCircle from '../.././components/css/dark/img//theme-images/info-circle.svg';

class ManageGroupNumber extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            toggleResetScreenPopup: false,
            toggleRequestGroupPopup: false,
            UserList: [],
            UserList_Temp: [],
            mainAPIresult: [],
            loader: true,
            saveLoader: false,
            userdata: JSON.parse(localStorage.getItem('user')),
            error: '',
            activePage: 1,
            mGroupSearch: '',
            currentPaging: 1,
            Data_Not_Found: '',
            copied: false,
            copy_tooltip: 'Deeplink-Click to Copy',
            copy_tooltip_portalLink: 'Enrollment Center - Click to Copy',
            IsResetDone: false,
            Resend_message: 'Resend Email',
            Resend_message_Broker: 'Resend Credentials',
            reopenFlag: 'direct',
            hideButton: false
        }
    }
    componentDidMount() {
        if (this.props.reopenFlag == 'Override') {
            this.handleSaveSubmit();
        } else {
            this.GetUserList_All(this.state.userdata.paramsname, this.state.userdata.wholesaler_Id, this.state.userdata.userrole, '');
        }
        $('.pagination li:first-child').text('First');
        $('.pagination li:last-child').text('Last');
        setTimeout(() => {
            $('.popup').addClass('mfp-ready');
            $('.popup').addClass('mfp-bg');
            $('.popup').addClass('mfp-with-anim');
        }, 5);
    }
    toggleRequestGroupPopup = () => {
        this.setState({
            toggleRequestGroupPopup: !this.state.toggleRequestGroupPopup,
        });
    }
    GetUserList_All(roleName, wholesaler_Id, roleType, searchtText) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ roleName, wholesaler_Id, roleType, searchtText })
            };
            return fetch(`/api/ws/whusers`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 10)
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: apidata, loader: false, error: '' });
                        else {
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
                            this.setState({ UserList: apidata, mainAPIresult: apidata, UserList_Temp: usertemplistobj, loader: false, error: '' });
                        }
                        if (this.props.mGroupPagin > 1) {
                            this.handlePageChange(this.props.mGroupPagin);
                        }
                        if (!userService.Check_Null_Empty(this.props.mGroupSearch)) {
                            $('#SearcInput').val(this.props.mGroupSearch);
                            this.FilterRecords();
                        }
                        if (this.props.confirmText == 'yes' && !this.state.IsResetDone) {
                            this.resetGroupNumber();
                        }
                        this.SearchOnKeyUp();
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    GetUserList_All_Override(roleName, wholesaler_Id, roleType, searchtText) {
        this.setState({ saveLoader: true });
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Browser-Url': window.location.href },
                body: JSON.stringify({ roleName, wholesaler_Id, roleType, searchtText })
            };
            return fetch(`/api/ws/whusers_override`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        if (apidata.length <= 10) {
                            this.setState({ UserList: apidata, UserList_Temp: apidata, loader: false, error: '', saveLoader: false });
                            $('.override-btn').addClass('get-response');
                            setTimeout(() => {
                                $('.override-btn').blur();
                            }, 300);
                        }
                        else {
                            let userlistobj = JSON.parse(JSON.stringify(apidata));
                            let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
                            this.setState({ UserList: apidata, UserList_Temp: usertemplistobj, loader: false, error: '', saveLoader: false });
                            $('.override-btn').addClass('get-response');
                            setTimeout(() => {
                                $('.override-btn').blur();
                            }, 300);
                        }
                        if (this.props.mGroupPagin > 1) {
                            this.handlePageChange(this.props.mGroupPagin);
                        }
                        if (this.props.confirmText == 'yes' && !this.state.IsResetDone) {
                            this.resetGroupNumber();
                        }
                    }
                    catch (error) {
                    }
                });
        }
        catch (error) {
        }
    }
    handleResponse(response) {
        return response.text().then(text => {
            try {
                const data = text && JSON.parse(text);
                return data;
            }
            catch (error) {
                const data = [];
                return data;
            }
        });
    }
    toogleResetGroupPopup = (e) => {
        let SelectedGroup = $(e.target).attr('data-gNumber');
        let TopCommission = $(e.target).attr('data-comm');
        this.props.closePopup(SelectedGroup, TopCommission, this.state.currentPaging, this.state.mGroupSearch, 'ResetGroup');
        this.props.openResetGroup('Are you sure want to reset details for this group number?');
    }
    resetGroupNumber = (e) => {
        this.Remove_Selected_Reps('0', this.props.selectedGroup, this.state.userdata.wholesaler_Id.toString());
    }
    Remove_Selected_Reps(UserId, GroupNumber, WhName) {
        try {
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserId, GroupNumber, WhName })
            };
            return fetch(`/api/ws/RemoveReps`, requestOptions)
                .then(this.handleResponse)
                .then(apidata => {
                    try {
                        this.setState({
                            toggleConfirmationPopup: !this.state.toggleConfirmationPopup
                        });
                        if (apidata.length > 0) {
                            if (apidata[0].code != "-1") {
                                this.setState({ error: 'Record reset successfully', IsResetDone: true });
                                setTimeout(() => {
                                    this.GetUserList_All(this.state.userdata.paramsname, this.state.userdata.wholesaler_Id, this.state.userdata.userrole, '');
                                    return false;
                                }, 1000)
                                $('#SearcInput').val('');
                            }
                            else {
                                this.setState({ loading: false, error: 'Error. Please try later.', IsResetDone: true });
                                return false;
                            }
                        }
                        else {
                            this.setState({ loading: false, error: 'Error. Please try later.', IsResetDone: true });
                            return false;
                        }
                    }
                    catch (error) {
                        this.setState({ loading: false, error: 'Error. Please try later.', IsResetDone: true });
                        return false;
                    }
                });
        }
        catch (error) {
            this.setState({ loading: false, error: 'Error. Whoops, something went wrong. Please try again.', IsResetDone: true });
            return false;
        }
    }
    toggleAssignPopup = (e) => {
        let SelectedGroup = $(e.target).attr('data-gNumber');
        let TopCommission = $(e.target).attr('data-comm');
        let NewUser = $(e.target).attr('data-newUser');
        this.props.closePopup(SelectedGroup, TopCommission, this.state.currentPaging, this.state.mGroupSearch, '', NewUser, this.state.reopenFlag, this.state.mainAPIresult);
        this.props.openAssignGroup(SelectedGroup);
    }
    toggleEditGroupPopup = (e) => {
        let SelectedGroup = $(e.target).attr('data-gNumber');
        let TopCommission = $(e.target).attr('data-comm');
        let NewUser = $(e.target).attr('data-newUser');
        this.props.closePopup(SelectedGroup, TopCommission, this.state.currentPaging, this.state.mGroupSearch, '', NewUser, this.state.reopenFlag, this.state.mainAPIresult);
        this.props.openEditGroup('', '', '', '', e.target.getAttribute('data-utype'), SelectedGroup);
    }
    toggleEditCampaignPopup = (e) => {
        let SelectedGroup = $(e.target).attr('data-gNumber');
        let TopCommission = $(e.target).attr('data-comm');
        let NewUser = $(e.target).attr('data-newUser');
        this.props.closePopup(SelectedGroup, TopCommission, this.state.currentPaging, this.state.mGroupSearch, '', NewUser, this.state.reopenFlag, this.state.mainAPIresult);
        this.props.openCampaign('', '', '', '', e.target.getAttribute('data-utype'), e.target.getAttribute('data-email'));
    }
    FilterRecords = () => {
        let serachText = $('#SearcInput').val();
        if (serachText.length <= 0) return;
        let userlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            //if (e1.distributorName != null)
            return (e1.distributorName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            // else return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        })
        let copyuserlistobj = JSON.parse(JSON.stringify(this.state.mainAPIresult)).filter(function (e1) {
            //if (e1.distributorName != null)
            return (e1.distributorName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.emailId.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            //else return (e1.groupNumber.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
        });

        let usertemplistobj = userlistobj.length > 12 ? userlistobj.splice(0, 12) : userlistobj;
        this.setState({ activePage: 0, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, mGroupSearch: serachText, loader: false });
    }
    SearchOnKeyUp = (e) => {
        let mainAPIresult;
        if (this.props.reopenFlag == 'Override') {
            mainAPIresult = this.props.allData;
        } else {
            mainAPIresult = this.state.mainAPIresult;
        }
        let serachText = $('#SearcInput').val().toLowerCase();
        try {
            if (serachText.length > 0) {
                this.setState({ hideButton: true });
            } else {
                this.setState({ hideButton: false });
            }
            if (this.state.UserList.length == 1) {
                let dd = JSON.parse(JSON.stringify(mainAPIresult));
                let userlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                    return (e1.distributorName.toLowerCase().indexOf(serachText) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                });
                let copyuserlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                    return (e1.distributorName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                });

                if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });

                let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;

                this.setState({ activePage: 1, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, mGroupSearch: serachText, loader: false });
                return;
            }
            if (serachText.length <= 0) {
                this.setState({ hideButton: false });
                if (e.keyCode == 46 || e.keyCode == 8) {
                    let dd = JSON.parse(JSON.stringify(mainAPIresult));
                    let userlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                        return (e1.distributorName.toLowerCase().indexOf(serachText) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                    });
                    let copyuserlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                        return (e1.distributorName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                    });
                    if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });
                    let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
                    this.setState({ activePage: 1, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, mGroupSearch: serachText, loader: false });
                } else {
                    let usertemplistobj = mainAPIresult.length > 10 ? [...mainAPIresult.slice(0, 10)] : mainAPIresult;
                    this.setState({ activePage: 1, UserList: mainAPIresult, UserList_Temp: usertemplistobj, mGroupSearch: serachText, loader: false });
                    return;
                }
            } else {
                this.setState({ hideButton: true });
                let dd = JSON.parse(JSON.stringify(mainAPIresult));
                let userlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                    return (e1.distributorName.toLowerCase().indexOf(serachText) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                });
                let copyuserlistobj = JSON.parse(JSON.stringify(mainAPIresult)).filter(function (e1) {
                    return (e1.distributorName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.groupNumber.indexOf(serachText.toUpperCase()) !== -1 || e1.emailId.indexOf(serachText) !== -1)
                });
                if (userlistobj.length == 0 || copyuserlistobj.length == 0) this.setState({ Data_Not_Found: 'No records found' });
                let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice(0, 10) : userlistobj;
                this.setState({ activePage: 1, UserList: copyuserlistobj, UserList_Temp: usertemplistobj, mGroupSearch: serachText, loader: false });
            }
        }
        catch (error) {
        }
    }
    handlePageChange = (pageNumber) => {
        let userlistobj = JSON.parse(JSON.stringify(this.state.UserList));
        let usertemplistobj = userlistobj.length > 10 ? userlistobj.splice((pageNumber - 1) * 10, 10) : userlistobj;
        this.setState({ activePage: pageNumber, UserList_Temp: usertemplistobj, loader: false, currentPaging: pageNumber });
    }
    resendEmail = (e) => {
        $(e.target).siblings('.hide-loader').css("display", "block");
        $(e.target).css("display", "none");
        this.Process_ResendDeepLink(e.target.getAttribute('text-email'), e.target.getAttribute('text-gn'));
    }
    resendEmail_Broker = (e) => {
        $(e.target).siblings('.hide-loader').css("display", "block");
        $(e.target).css("display", "none");
        this.Process_ResendEmail_Broker(e.target.getAttribute('text-email'), e.target.getAttribute('text-gn'));
    }
    Process_ResendDeepLink(Uemail, Uname) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Uemail, Uname })
        };
        return fetch(`/api/ws/dlinkmailtrigger`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                if (apidata.length > 0) {

                    if (apidata[0].code == "1") {
                        this.setState({ Resend_message: apidata[0].message, IsResetDone: true });
                        $('.hover-tooltip').addClass("sent");
                        $('.hide-loader').css("display", "none");
                        $('.custom-tooltip img').css("display", "block");
                        setTimeout(() => {
                            this.setState({ Resend_message: 'Resend Email' });
                            $('.hover-tooltip').removeClass("sent");
                        }, 2000);
                    } else {
                        this.setState({ Resend_message: apidata[0].message, IsResetDone: true });
                        $('.hover-tooltip').addClass("sent");
                        setTimeout(() => {
                            this.setState({ Resend_message: 'Resend Email' });
                            $('.hover-tooltip').removeClass("sent");
                        }, 2000);
                    }

                } else {
                    $('.hover-tooltip').addClass("sent");
                    this.setState({ Resend_message: 'Error. Please try later.', IsResetDone: true });
                    setTimeout(() => {
                        this.setState({ Resend_message: 'Resend Email' });
                        $('.hover-tooltip').removeClass("sent");
                    }, 2000);

                }
            });
    }
    Process_ResendEmail_Broker(Uemail, Uname) {
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ Uemail, Uname })
        };
        return fetch(`/api/broker/reset_credential`, requestOptions)
            .then(this.handleResponse)
            .then(apidata => {
                try {
                    if (apidata.length > 0) {
                        if (apidata[0].code == 200 && apidata[0].success == true) {
                            this.setState({ error: apidata[0].detail[0].messagedetail, IsResetDone: true });
                            $('.custom-tooltip img').css("display", "block");
                            $('.hide-loader').css("display", "none");
                            setTimeout(() => {
                                this.setState({ error: '' });
                            }, 3000);
                        } else {
                            $('.custom-tooltip img').css("display", "block");
                            $('.hide-loader').css("display", "none");
                            this.setState({ error: apidata[0].detail[0].messagedetail, IsResetDone: true });
                            setTimeout(() => {
                                this.setState({ error: '' });
                            }, 3000);
                        }
                    } else {
                        $('.custom-tooltip img').css("display", "block");
                        $('.hide-loader').css("display", "none");
                        this.setState({ error: 'Error. Please try later.', IsResetDone: true });
                        setTimeout(() => {
                            this.setState({ error: '' });
                        }, 3000);
                    }
                } catch (error) {
                    $('.custom-tooltip img').css("display", "block");
                    $('.hide-loader').css("display", "none");
                    this.setState({ error: 'Error. Please try later.', IsResetDone: true });
                    setTimeout(() => {
                        this.setState({ error: '' });
                    }, 3000);
                }
            });
    }
    Copytext = (e) => {
        copy(e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip: "Copied" });
        setTimeout(() => {
            this.setState({ copy_tooltip: "Deeplink-Click to Copy" });
        }, 600)
    }
    Copytext_portalLink = (e) => {
        copy(e.target.getAttribute('data-text'));
        this.setState({ copy_tooltip_portalLink: "Copied" });
        setTimeout(() => {
            this.setState({ copy_tooltip_portalLink: "Enrollment Center - Click to Copy" });
        }, 600)
    }
    specialCase = () => {
        this.setState({ error: 'This action is not available', loader: false });
    }
    handleSaveSubmit = () => {
        let serachText;
        if (this.props.reopenFlag == 'Override') {
            serachText = this.props.mGroupSearch;
            this.setState({ mainAPIresult: this.props.allData });
        } else {
            serachText = $('#SearcInput').val().toLowerCase();
        }
        $('#SearcInput').val(serachText);
        this.GetUserList_All_Override(this.state.userdata.paramsname, this.state.userdata.wholesaler_Id, this.state.userdata.userrole, serachText);
        this.setState({ reopenFlag: 'Override', mGroupSearch: serachText });
    }
    render() {
        const { error } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;
        return (
            <div className='popup mfp-zoom-in'>
                <div className='popup_inner manage-distributor-design wh-manage-gnumber'>
                    {
                        this.state.loader ? (<div className="theme-loader"></div>) : null
                    }
                    <h1>{this.props.text}<button onClick={this.props.closePopup}>X</button></h1>
                    {/*<a href="javascript:void('0')" className="request-new" onClick={this.toggleRequestGroupPopup}>Request new group number</a>*/}

                    <div className="searchSection populate">
                        <form autoComplete="off" onSubmit={e => { e.preventDefault() }}>
                            <div className="autocomplete">
                                <input id="SearcInput" disabled={disabled} type="text" name="PhCityInput" scroll-id="CITY" data-id="dynamic" placeholder="Search" onChange={this.SearchOnKeyUp} className="form-control searchTable searchtextarea" />
                                {
                                    this.state.hideButton ?
                                        <input type="button" className={this.state.saveLoader ? 'btn save-btn override-btn animated-btn' : 'btn save-btn override-btn'} onClick={this.handleSaveSubmit} value="Search Overrides" />
                                        : null
                                }
                                <div class="save-btn-loader">
                                    {
                                        this.state.saveLoader ? (<div className="theme-loader save-loader"></div>) : null
                                    }
                                </div>
                            </div>
                        </form>
                    </div>

                    <div className="list-section">

                        {
                            this.state.UserList != null && this.state.UserList.length > 0 ?
                                <table>
                                    <thead>
                                        <tr className="header">
                                            <th className="first-one">Group Number</th>
                                            <th className="second-one">User Type</th>
                                            <th className="third-one">Name</th>
                                            <th className="fourth-one"><span className="text">Commission</span>
                                                <div className="tool-tip-section mg-info">
                                                    <img className="infoCircle" src={InfoCircle} alt="InfoCircle" />
                                                    <span className="toolTipContent">Includes Override Commission</span>
                                                </div>
                                            </th>
                                            <th className="fifth-one">Action</th>
                                        </tr>
                                    </thead>
                                    <tbody id="inactive_reps">
                                        {
                                            this.state.UserList_Temp.map((e1, i1) => {
                                                return (
                                                    <tr className="userDashData">
                                                        <td className="first-one">{e1.groupNumber}</td>
                                                        <td className="second-one">{e1.userType}</td>
                                                        <td className="third-one">{e1.distributorName}</td>
                                                        <td className="fourth-one">{e1.commissionPayable}</td>
                                                        <td className={e1.isAssigned && e1.isGlicRx && e1.deepLink != null && e1.deepLink != "" ? 'fifth-one' : 'fifth-one deeplink-hide'}>
                                                            {
                                                                !e1.isAssigned ?
                                                                    <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.toggleAssignPopup} data-newUser={true} data-gNumber={e1.groupNumber} data-comm={e1.topCommission} data-utype={e1.userType} data-dName={e1.distributorName} src={UserIcon} className="userIcon" alt="userIcon" /> <span className="hover-tooltip createNew user">Assign</span></a> :
                                                                    <div>
                                                                        {
                                                                            e1.userType == 'Web Campaign' && e1.emailId == this.state.userdata.email ? null :
                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img onClick={e1.userType == "Web Campaign" ? this.toggleEditCampaignPopup : this.toggleEditGroupPopup} src={EditIcon} data-newUser={false} data-gNumber={e1.groupNumber} data-comm={e1.topCommission} data-utype={e1.userType} data-dName={e1.distributorName} data-email={e1.emailId} className="editIcon" alt="editIcon" /><span className="hover-tooltip createNew edit">Edit</span></a>
                                                                        }
                                                                    </div>
                                                            }
                                                            {
                                                                !e1.isAssigned ?
                                                                    null :
                                                                    <div>
                                                                        {
                                                                            e1.userType == 'Web Campaign' && e1.emailId == this.state.userdata.email ? null :
                                                                                <a href="javascript:void('0')" className="custom-tooltip"><img onClick={this.state.userdata.wholesaler_Id == 61 ? this.specialCase : this.toogleResetGroupPopup} data-gNumber={e1.groupNumber} src={ResetIcon} className="resetIcon" alt="ResetIcon" /><span className="hover-tooltip createNew">Reset</span></a>
                                                                        }
                                                                    </div>
                                                            }
                                                            {
                                                                e1.isAssigned && e1.isGlicRx && e1.deepLink != null && e1.deepLink != "" ?
                                                                    <a href="javascript:void('0')" className="custom-tooltip"><img data-text={e1.deepLink} onClick={this.Copytext} data-gNumber={e1.groupNumber} src={CopyIcon} className="CopyIcon" alt="Copy Icon" /><span className="hover-tooltip copylink">{this.state.copy_tooltip}</span></a> : null
                                                            }
                                                            {
                                                                e1.userType != 'Broker' && e1.isAssigned && e1.isGlicRx && e1.deepLink != null && e1.deepLink != "" ?
                                                                    <a href="javascript:void('0')" className="custom-tooltip"><div className="hide-loader"><div className="theme-loader resetLoader"></div></div><img text-name={e1.distributorName} text-email={e1.emailId} onClick={this.resendEmail} text-gn={e1.groupNumber} src={ResendIcon} className="resendIcon" alt="Resend Icon" /><span className="hover-tooltip resendEmail">{this.state.Resend_message}</span></a> : null
                                                            }
                                                            {
                                                                e1.userType == 'Broker' && e1.portalLink != null && e1.portalLink != "" ?
                                                                    <a href="javascript:void('0')" className="custom-tooltip"><img data-text={e1.portalLink} onClick={this.Copytext_portalLink} data-gNumber={e1.groupNumber} src={GlobeIcon} className="CopyIcon" alt="Globe Icon" /><span className="hover-tooltip copylink globe">{this.state.copy_tooltip_portalLink}</span></a> : null
                                                            }
                                                            {
                                                                e1.userType == 'Broker' && e1.isAssigned && e1.isGlicRx && e1.deepLink != null && e1.deepLink != "" ?
                                                                    <a href="javascript:void('0')" className="custom-tooltip"><div className="hide-loader"><div className="theme-loader resetLoader"></div></div><img text-name={e1.distributorName} text-email={e1.emailId} onClick={this.resendEmail_Broker} text-gn={e1.groupNumber} src={ResendIcon} className="resendIcon" alt="Resend Icon" /><span className="hover-tooltip resendEmail re-credientials">{this.state.Resend_message_Broker}</span></a> : null
                                                            }
                                                        </td>
                                                    </tr>)
                                            })
                                        }
                                    </tbody> </table> :
                                <div>
                                    {
                                        this.state.loader ?
                                            <div className="please-wait"><h3>Please wait...</h3></div> :
                                            <div className="please-wait color-red"><h3>{this.state.Data_Not_Found}</h3></div>
                                    }
                                </div>

                        }

                        {
                            this.state.UserList != null && this.state.UserList.length > 0 ?
                                <Pagination
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={10}
                                    totalItemsCount={this.state.UserList.length}
                                    pageRangeDisplayed={5}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                                : null
                        }
                        {
                            this.state.toggleRequestGroupPopup ?
                                <RequestGroupNumber text='Request Group Number' calldata={"callonce"} closePopup={this.toggleRequestGroupPopup.bind(this)} /> : null
                        }

                        {error &&
                            <div className={'alert alert-danger'}>{error}</div>
                        }
                    </div>
                </div>
            </div>
        );
    }
}
export default ManageGroupNumber;